// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"163":"3f50dc3c","485":"f389f6d4","574":"d24a2863"}[chunkId] + ".css";
};